import React from "react";
import SelectInputField, { SelectInputFieldProps } from "./SelectInputField";
import { countryCodes } from "../formLayouts/countryCodes";

type CountryCodeSelectProps = Omit<SelectInputFieldProps, "options">;
const CountryCodeSelect: React.FC<CountryCodeSelectProps> = (props) => {
  const { defaultValue, ...rest } = props;

  const countryOptions = countryCodes.map(
    (country) => `${country.abbreviation} (+${country.code})`
  );
  return (
    <SelectInputField
      {...rest}
      defaultValue={defaultValue}
      options={countryOptions}
    />
  );
};

export default CountryCodeSelect;
